/** @format */

export interface CriteoTransactionMetadata {
	currency?: string;
	items: string;
	prices: string;
	quantities: string;
	transactionId: string;
}

export interface CriteoTrackTransactionResponse {
	OnLoadBeacon: string;
}

export interface CriteoViewItemMetadata {
	availability: number;
	category?: string;
	item: string;
	parentItem?: string;
	price: string;
}

export interface CriteoViewProductsMetadata {
	category: string;
	filters?: string;
	item?: string;
	listSize?: number;
	pageNumber?: number;
	parentItem?: string;
	productType: ProductTypes;
}

export enum ProductTypes {
	VIEW_CATEGORY,
	VIEW_SEARCH_RESULT
}

export interface CriteoViewProductsResponse {
	OnLoadBeacon: string;
	placements: [CriteoCarouselPlacement, CriteoInGridPlacement];
}

export interface CriteoViewItemResponse {
	OnLoadBeacon: string;
	placements: CriteoCarouselPlacement[];
}

export interface CriteoInGridPlacement {
	inGrid: CriteoPlacement[];
}

export interface CriteoCarouselPlacement {
	carousel: CriteoPlacement[];
}

export interface CriteoPlacement {
	OnClickBeacon: string;
	OnLoadBeacon: string;
	OnViewBeacon: string;
	format: string;
	products: CriteoProduct[];
	rendering: string;
}

export interface CriteoProduct {
	AdvertiserId: string;
	ClientAdvertiserId: string;
	ComparePrice: string;
	Image: string;
	LineItemID: string;
	OnBasketChangeBeacon: string;
	OnClickBeacon: string;
	OnLoadBeacon: string;
	OnViewBeacon: string;
	OnWishlistBeacon: string;
	ParentSKU: string;
	Price: string;
	ProductId: string;
	ProductName: string;
	ProductPage: string;
	PromoText: string;
	Rating: string;
	RenderingAttributes: string;
	Shipping: string;
}
